import React from 'react';
import {Route, Redirect} from 'react-router-dom';
// import {} from

const UserRoute=({component: Component,...rest})=>{
    let authuser = sessionStorage.getItem('Key_Veriable')
    return(<Route
            {...rest}
                render ={(props)=>
                authuser==='USER'? (<Component {...props} />) :(<Redirect to ='/signin'/>)}/> )
};
export default UserRoute